import React, { useEffect } from "react";
import SectionMain from "../../components/SectionMain";
import { Hidden } from "@material-ui/core";
import { useUpdateUser } from "../../hooks/useUpdateUser";
import GiftCardScreenDesktop from "./desktop";
import GiftCardScreenMobile from "./mobile";

const GiftCardPage = () => {
  const UpdateUser = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    await useUpdateUser();
  };
  useEffect(() => {
    UpdateUser();
  }, []);

  return (
    <SectionMain noPadding>
      <Hidden only={["xs", "sm", "md"]}>
        <GiftCardScreenDesktop />
      </Hidden>
      <Hidden only={["lg", "xl"]}>
        <GiftCardScreenMobile />
      </Hidden>
    </SectionMain>
  );
};

export default GiftCardPage;
